import React from 'react';

interface PullQuoteProps {
  children: React.ReactNode;
}

const PullQuote = ({ children }: PullQuoteProps) => {
  return (
    <aside className="my-12 sm:my-14 md:my-16 font-display font-medium text-[1.6rem] sm:text-[1.9rem] leading-[1.45] text-foreground">
      {children}
    </aside>
  );
};

export default PullQuote;
